/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function DashboardIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "dashboard", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M19.5 19.5H5.5V5.5H19.5V19.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5.5 12.5H19.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M14.5 19.5V12.5M10.5 12.5V5.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(DashboardIcon);
export default ForwardRef;
//# sourceMappingURL=dashboardIcon.js.map